import { analytics } from './analytics';
import { extendSocialShare } from './extensions/social-share';
import { extendSupportAssistant } from './extensions/support-assistant';
import { registerWistiaAnalytics } from './providers/wistia';
import { registerVidyardAnalytics } from './providers/vidyard';
import { registerMarketoAnalytics } from './providers/marketo';
import { registerHtml5VideoAnalytics } from './rules/html5-video';
import { registerRelatedContentBlogAnalytics } from './rules/related-content-blog';
import { registerRoyaltyDropdownAnalytics } from './rules/royalty-dropdown';
import { registerSupportAssistantAnalytics } from './rules/support-assistant';
import { registerBannerAnalytics } from './rules/banner-analytics';
import { getGoogleAnalytics, sendLegacyGA } from './utils/legacy-ga';

registerHtml5VideoAnalytics();
registerWistiaAnalytics();
registerVidyardAnalytics();
registerMarketoAnalytics();
registerRelatedContentBlogAnalytics();
registerRoyaltyDropdownAnalytics();
registerSupportAssistantAnalytics();
registerBannerAnalytics();

const clickAnalytics = analytics('.mh-analytic').name('aem-click').on('click').collectCommon();

extendSocialShare(clickAnalytics);
extendSupportAssistant(clickAnalytics);

clickAnalytics.emit();

document.addEventListener('click', (event: Event) => {
  const element = event.target instanceof Element ? event.target.closest('.mh-analytic') : null;
  if (element) sendLegacyGA(getGoogleAnalytics(element));
});

export { clickAnalytics };
